import { RECENT_GAMES_VISIBLE } from '../constants'

export interface RecentGamesSplit<T> {
  /** Always on screen. */
  visible: T[]
  /** Behind "View More"; empty when everything fits. */
  more: T[]
}

/** The first `limit` recent games stay visible; the rest open on demand. */
export const splitRecentGames = <T>(
  games: T[],
  limit: number = RECENT_GAMES_VISIBLE
): RecentGamesSplit<T> => ({
  visible: games.slice(0, limit),
  more: games.slice(limit),
})
